import React from "react"
import { Alert } from 'reactstrap';

export const AlertDanger = (props) => {
    return (
      <Alert color="danger">{props.children}</Alert>
    )
}
  